/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Code({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M9.098 2.554a.6.6 0 1 0-1.196-.108l-1 11a.6.6 0 1 0 1.196.108zM4.924 11.924a.6.6 0 0 1-.848 0l-3.5-3.5a.6.6 0 0 1 0-.848l3.5-3.5a.6.6 0 0 1 .848.848L1.85 8l3.075 3.076a.6.6 0 0 1 0 .848M11.076 11.924a.6.6 0 0 0 .848 0l3.5-3.5a.6.6 0 0 0 0-.848l-3.5-3.5a.6.6 0 1 0-.848.848L14.152 8l-3.076 3.076a.6.6 0 0 0 0 .848" /></svg>;
}
;